import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '../../context'
import Slide from '../ui/Slide'
import { getUserProfile, dismissCompleteProfilePopup } from '../../api'
import type { IUserData } from '../../typings/common'

interface ProfileData extends IUserData {
  isFollowed?: boolean
}

const CompleteProfilePopover: React.FC = () => {
  const {
    onTogglePopover,
    setUserHasDismissedCompleteProfilePopup,
    activePopover
  } = useContext(AppContext)
  const profileUrl = `${process.env.REACT_APP_SOCIAL_URL}user-profile`

  const [isProfileComplete, setIsProfileComplete] = useState<boolean>(false)
  const [userProfile, setUserProfile] = useState<ProfileData | null>(null)

  const isActive = activePopover === 'complete-profile'

  function completeYourProfileLaterClicked() {
    onTogglePopover('')
    setUserHasDismissedCompleteProfilePopup(true)
    dismissCompleteProfilePopup()
  }

  useEffect(() => {
    const hasUserCompletedProfile = async () => {
      const data = await getUserProfile()

      if (data !== null) {
        setIsProfileComplete(data.hasCompletedProfile)
        setUserProfile(data)
      }
    }

    if (isActive && userProfile === null) {
      hasUserCompletedProfile()
    }
  }, [isActive])

  return (
    <>
      {!isProfileComplete && (
        <AppContext.Consumer>
          {({ onTogglePopover }) => (
            <Slide
              isVisible={isActive}
              id="complete-your-profile-overlay"
              className="overlay overlay-left"
            >
              <div id="complete-your-profile-header">
                <a
                  className="close-button btn-pill no-fill no-label"
                  onClick={() => onTogglePopover('')}
                >
                  <span className="material-icons">clear</span>
                </a>
              </div>
              <div id="complete-your-profile-container">
                <h4>Complete your Explore profile</h4>
                <p>
                  To view and create social posts, and to add comments and new
                  locations as a member, you'll need to{' '}
                  <b>complete your profile.</b>
                </p>
                <a
                  id="complete-profile-button"
                  className="btn btn-primary"
                  href={profileUrl}
                  target="_blank"
                >
                  Complete profile
                </a>
                <a
                  id="complete-profile-later-button"
                  className="btn btn-secondary"
                  onClick={completeYourProfileLaterClicked}
                >
                  Remind me later
                </a>
              </div>
            </Slide>
          )}
        </AppContext.Consumer>
      )}
    </>
  )
}

export default CompleteProfilePopover
